import React from 'react';

import { UrlUploadField } from '../../../../../../../small_views/formik_components/url_upload_field/url_upload_field';

const GameStepFormUrlUploadFieldComponent = ({ projectDocumentId, documentId, ...props }) => (
    <UrlUploadField path={`/projects/${projectDocumentId}/steps/${documentId}`} fileName="content" {...props} />
);

export const GameStepFormUrlUploadField = GameStepFormUrlUploadFieldComponent;
